






import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Message, JinroPlayerDocument } from "@/services/datatypes";
import { PUBLIC_VIEWER_POSTER_NAME_SUFFIX } from "@/services/constants";
import ChatMessage from "@/components/shared/ChatMessage.vue";

@Component({
  components: {
    ChatMessage
  }
})
export default class ChatActivity extends Vue {
  @Prop() readonly message!: Message;
  get isValidMessage(): boolean {
    if (!this.message || !this.message.type) return false;
    return this.message.type === "chat";
  }
}
